export const REGISTRATION_TERMS_OPTIONS = [
  'I have read and agree to the terms and conditions set out in THE PROCESSING OF PERSONAL DATA: AGREEMENT (GDPR)',
  'I have read and agree to the terms and conditions set out in SCHEDULE 1 - DETAILS OF THE PROCESSING OF YOUR PERSONAL DATA',
  'I have read and agree to the terms and conditions set out in SCHEDULE 2 - STANDARD CONTRACTUAL CLAUSES including APPENDIX 1 and APPENDIX 2',
  'I have read and agree to the terms and conditions set out in Terms of Use (Terms and Conditions)',
];

export function areAllRegistrationTermsAccepted(value) {
  return Array.isArray(value) && value.length >= REGISTRATION_TERMS_OPTIONS.length;
}

export function validateRegistrationTerms(_rule, value, callback) {
  if (areAllRegistrationTermsAccepted(value)) {
    callback();
    return;
  }
  callback('Please accept all terms and conditions before activating your account.');
}
